var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoShort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 82,
    viewBox: "0 0 83 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.7138 34.4645L40.4975 1.2482C39.7 0.450734 38.6252 0 37.481 0C36.3368 0 35.2619 0.450734 34.4645 1.2482L1.24821 34.4645C-0.41607 36.1287 -0.41607 38.8332 1.24821 40.4975C2.91249 42.1618 5.65162 42.1618 7.3159 40.4975L9.77764 38.0704V66.1551C9.77764 68.5129 11.65 70.3158 14.0077 70.3158H60.9889C63.3467 70.3158 65.2537 68.5129 65.2537 66.1551V38.0704L67.6807 40.4975C68.5129 41.3296 69.6224 41.7457 70.6973 41.7457C71.7721 41.7457 72.8816 41.3296 73.7138 40.4975C75.378 38.8332 75.378 36.1287 73.7138 34.4645ZM56.5509 61.9944H18.4111V34.9499H56.5509V61.9944ZM21.4276 26.2818L37.481 10.2284L53.5344 26.2818H21.4276Z",
    fill: "#60C3AD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.2189 36.3018H56.5508V47.0502H65.2189V36.3018Z",
    fill: "url(#paint0_linear)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2292 61.959H35.4004V70.2804H48.2292V61.959Z",
    fill: "url(#paint1_linear)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.96 63.0679C80.96 73.5043 72.4999 81.9991 62.0288 81.9991C51.5924 81.9991 43.0977 73.539 43.0977 63.0679C43.0977 52.6315 51.5577 44.1367 62.0288 44.1367C72.4999 44.1367 80.96 52.6315 80.96 63.0679Z",
    fill: "#004B5B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.9595 75.655C61.0927 75.655 60.2953 75.3083 59.6712 74.7189L51.1764 66.2241C49.9282 64.9759 49.9282 62.9302 51.1764 61.6473C52.4246 60.3991 54.4703 60.3991 55.7532 61.6473L61.9595 67.8537L77.2501 52.5631C78.4983 51.3149 80.544 51.3149 81.8269 52.5631C83.0751 53.8113 83.0751 55.857 81.8269 57.1399L64.2479 74.7189C63.6238 75.343 62.7917 75.655 61.9595 75.655Z",
    fill: "url(#paint2_linear)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6822 72.9499C60.8154 72.9499 60.0179 72.6032 59.3938 72.0138L50.899 63.519C49.6508 62.2708 49.6508 60.2251 50.899 58.9422C52.1473 57.694 54.1929 57.694 55.4758 58.9422L61.6822 65.1486L76.9728 49.858C78.221 48.6098 80.2666 48.6098 81.5495 49.858C82.7977 51.1062 82.7977 53.1519 81.5495 54.4348L63.9706 72.0138C63.3812 72.6032 62.549 72.9499 61.6822 72.9499Z",
    fill: "#60C3AD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 60.8848,
    y1: 36.311,
    x2: 60.8848,
    y2: 47.0595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B8BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 35.4004,
    y1: 66.1289,
    x2: 48.2292,
    y2: 66.1289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B8BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 73.4846,
    y1: 52.4019,
    x2: 59.0254,
    y2: 66.8611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B8BA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShort);
export default __webpack_public_path__ + "static/media/logo-short.3b51fd2b.svg";
export { ForwardRef as ReactComponent };